/* eslint-disable no-unused-vars */
import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { components } from 'react-select';

import HelpBallon from '../../Intelligence/component/HelpBalloon/HelpBalloon';
import Select from '../../Select';
import { BotsCreators } from '../../../store/actions/bots';

const BotTransferSettings = (props) => {
  const { item, bots, bot, answerHandlerOpen, toggleAnswerHandler } = props;
  const [exportVariables, setExportVariables] = useState(
    item?.botTransfer?.exportVariables || false
  );
  const [selectedTransfer, setSelectedTransfer] = useState(null);

  useEffect(() => {
    if (!bots) {
      const { listBotsRequest } = props;
      listBotsRequest();
    }
  }, [bots]);

  useEffect(() => {
    if (bots && item) {
      const { id, exportVariables: newExportVariables } = item.botTransfer;
      const selectedBot = bots.find(({ _id }) => _id === id);

      if (selectedBot) {
        setSelectedTransfer({
          value: selectedBot._id,
          label: selectedBot.title,
        });
      } else {
        setSelectedTransfer(null);
      }
      setExportVariables(newExportVariables);
    }
  }, [bots, item]);

  const destinyBotOptions = useMemo(() => {
    if (!bots) {
      return [];
    }
    const newBots = bots.filter(({ _id }) => _id !== bot._id);
    return newBots.map((b) => ({ value: b._id, label: b.title }));
  }, [bots]);

  const onChangeTransferSelect = useCallback((option) => {
    const { doUpdateItem } = props;
    if (!option) {
      doUpdateItem({ botTransfer: {} });
      setSelectedTransfer(null);
      return;
    }

    const newBotTransfer = {
      id: option.value,
      exportVariables,
    };
    setSelectedTransfer(option);
    doUpdateItem({ botTransfer: newBotTransfer });
  }, []);

  const optionBotTransfer = (optionProps) => {
    const { data } = optionProps;
    return (
      <components.Option {...optionProps}>
        <strong>{data.label}</strong>
        <br />
        <span>{data.value}</span>
      </components.Option>
    );
  };

  const onChangeExportVariablesCheck = (event) => {
    const { doUpdateItem } = props;
    const { checked } = event.target;
    const newBotTransfer = {
      id: selectedTransfer?.value || '',
      exportVariables: checked,
    };

    setExportVariables(checked);
    doUpdateItem({ botTransfer: newBotTransfer });
  };

  const renderBotTransferSelect = () => {
    if (!answerHandlerOpen) {
      return false;
    }

    return (
      <div style={{ marginTop: 5 }}>
        <Select
          className="pt-0 mb-2"
          label="Transferir para"
          options={destinyBotOptions}
          value={selectedTransfer}
          onChange={onChangeTransferSelect}
          isClearable
          components={{ Option: optionBotTransfer }}
        />
      </div>
    );
  };

  return (
    <div>
      <div className="bot-transfer-settings-options-divider" />
      <p className="pointer handler-title" onClick={toggleAnswerHandler}>
        Bot
        <img
          alt=""
          className={`seta-expander ${
            !answerHandlerOpen ? 'arrow-rotation' : ''
          }`}
          src="/assets/images/icons/seta_close.svg"
        />
      </p>
      {renderBotTransferSelect()}
      <div className="form-group row mb-1">
        <div className="custom-control custom-switch mt-2">
          <input
            type="checkbox"
            className="custom-control-input"
            id="checkBotTransfer"
            checked={exportVariables}
            onChange={onChangeExportVariablesCheck}
          />
          <label className="custom-control-label" htmlFor="checkBotTransfer">
            exportar variáveis
          </label>

          <HelpBallon
            id="help-ballon-check-agente"
            message="Se ativada, a Boteria transfere todas as informações coletadas para o bot seguinte."
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    bot: state.bots.bot,
    bots: state.bots.list,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ ...BotsCreators }, dispatch);
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BotTransferSettings)
);
